var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.authenticated
    ? _c(
        "nav",
        { staticClass: "navbar navbar-expand-md navbar-light bg-light" },
        [
          _c("a", { staticClass: "navbar-brand", attrs: { href: "#" } }, [
            _c("img", {
              attrs: {
                src: require("@/assets/logo.png"),
                height: "28",
                alt: "CoolBrand"
              }
            })
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "collapse navbar-collapse",
              attrs: { id: "navbarCollapse" }
            },
            [
              _c(
                "div",
                { staticClass: "navbar-nav" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-item nav-link active",
                      attrs: { to: "/" }
                    },
                    [_vm._v("Home")]
                  ),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-item nav-link",
                      attrs: { to: "/about" }
                    },
                    [_vm._v("About")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    { staticClass: "nav-item nav-link", attrs: { href: "#" } },
                    [_vm._v("Profile")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    { staticClass: "nav-item nav-link", attrs: { href: "#" } },
                    [_vm._v("Messages")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "nav-item nav-link disabled",
                      attrs: { href: "#", tabindex: "-1" }
                    },
                    [_vm._v("Reports")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "navbar-nav ml-auto" },
                [
                  this.$authenticated
                    ? _c(
                        "router-link",
                        {
                          staticClass: "nav-item nav-link",
                          attrs: { to: "/login", replace: "" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.logout()
                            }
                          }
                        },
                        [_vm._v("Logout")]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "navbar-toggler",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#navbarCollapse"
        }
      },
      [_c("span", { staticClass: "navbar-toggler-icon" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e7627c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e7627c0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/partials/Header.vue
// module id = null
// module chunks = 